/** Customer-facing tender labels — same wording as the POS Payment dialog. */
const PAYMENT_METHOD_LABELS: Record<string, string> = {
  CASH: 'Cash',
  CARD: 'Card',
  MOBILE_WALLET: 'JazzCash/EP',
  QR_CODE: 'QR Code',
  BANK_TRANSFER: 'Bank transfer',
  CREDIT: 'On account (Credit)',
  CHEQUE: 'Cheque',
  GIFT_CARD: 'Gift Card',
};

export function paymentMethodLabel(method: string | undefined): string {
  if (!method) return '';
  return PAYMENT_METHOD_LABELS[method] ?? method.replace(/_/g, ' ');
}
